const Checkboxes = ({ label, reqd, data, values, click }) => {
  const labels = data.map((item, index) => {
    return (
      <label key={index} style={{ display: "flex", alignItems: "center" }}>
        <input
          type="checkbox"
          name={item.name}
          value={item.val}
          defaultChecked={values.includes(item.val)}
          onClick={(e) => click(item.name, e.target.checked, e.target.value)}
          disabled={item.disabled ? true : false}
        />
        <span className={item.disabled ? "disabled" : ""}>
          {item.label ? item.label : item.val}
        </span>
      </label>
    );
  });

  return (
    <div>
      {label && (
        <label>
          {label} {reqd && <span className="reqd">*</span>}
        </label>
      )}
      <div>{labels}</div>
    </div>
  );
};

export default Checkboxes;
